import React from 'react';
import ReactDOM from 'react-dom';
import CalculatorInput from 'CalculatorInput';
import { Desktop, LargeMobile } from 'Responsive';
import { formatNumber } from 'Utils';

class NetWorthCalculator extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <NetWorthCalculator {...props} />,
      document.getElementById(id),
    );
  }

  static renderDetails() {
    return (
      <div className="net-worth-calculator-description">
        <h3>Net Worth Calculator</h3>
        <h4>Methodology</h4>
        <p>
            The Net Worth Calculator was created so you can determine your approximate net worth,
            and determine what net worth percentile you fall into. Input your total
            assets (aka all of your stuff -- cars, house, investment portfolios, etc.)
            and your liabilities (aka all of your debts -- student loan debt, credit
            card debt, home loan debt), to calculate your total net worth (assets minus
            liabilities) and your net worth bracket based on the 2016 dollar cutoff.
          </p>
      </div>
    );
  }

  constructor() {
    super();
    this.state = {
      totalAssets: '',
      totalLiabilities: '',
      netWorth: '',
      percentileBracket: '',
    };
    this.calculateResults = this.calculateResults.bind(this);
    this.calculateNetWorthBracket = this.calculateNetWorthBracket.bind(this);
  }

  calculateNetWorthBracket(netWorth) {
    const percentiles = ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '95%', '99%'];
    const cutoffs2016 = [-962.66, 4798.06, 18753.84, 49132.21, 97225.55, 169550.64,
      279554.27, 499263.50, 1182390.36, 2377985.22, 10374030.10];

    for (let cutoff = cutoffs2016.length - 1; cutoff >= 0; cutoff -= 1) {
      if (netWorth >= cutoffs2016[cutoff]) {
        return percentiles[cutoff];
      }
    }
    return '10%';
  }

  calculateResults() {
    const totalAssets = Number(this.state.totalAssets);
    const totalLiabilities = Number(this.state.totalLiabilities);
    const netWorth = totalAssets - totalLiabilities;

    this.setState({
      netWorth: formatNumber(netWorth.toFixed(2)),
      percentileBracket: this.calculateNetWorthBracket(netWorth),

    });
  }

  render() {
    return (
      <div className="container net-worth-calculator-container">
        <div className="row">
          <div className="col-xs-12 col-md-2 col-md-offset-1 net-worth-calculator-inputs">
            <LargeMobile>
              {NetWorthCalculator.renderDetails()}
            </LargeMobile>
            <CalculatorInput
              title="TOTAL ASSETS"
              value={this.state.totalAssets}
              onChange={totalAssets => this.setState({ totalAssets })}
              type="monetary"
            />
            <CalculatorInput
              title="TOTAL LIABILITIES"
              value={this.state.totalLiabilities}
              onChange={totalLiabilities => this.setState({ totalLiabilities })}
              type="monetary"
            />
            <span className="divider" />
            <button onClick={this.calculateResults}> Calculate </button>
          </div>
          <div className="col-xs-12 col-md-7 col-md-offset-1 net-worth-calculator-right-col">
            <Desktop>
              {NetWorthCalculator.renderDetails()}
            </Desktop>
            <div className="net-worth-calculator-results-container">
              <div className="caret" />
              <div className="net-worth-calculator-results-wrapper">
                <div className="net-worth-calculator-results">
                  <CalculatorInput
                    title="NET WORTH"
                    value={this.state.netWorth}
                    type="monetary"
                    disabled
                  />
                </div>
                <div className="net-worth-calculator-results">
                  <CalculatorInput
                    title="NET WORTH BRACKET"
                    value={this.state.percentileBracket}
                    type="percent"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NetWorthCalculator;



// WEBPACK FOOTER //
// ./src-react/NetWorthCalculator/index.jsx